<template lang="html">
    <md-list-item>
        <md-icon>whatshot</md-icon>
        <span>Dates</span>
        <md-list-expand>
        <md-list>
            <md-list-item class="md-inset">Start Date to End Date</md-list-item>
        </md-list>
        </md-list-expand>
    </md-list-item>
</template>

<script>
export default {
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/dateFilter.vue